const moment = require('moment')

export default ({ store, ssr, eventer, srv }) => {
	if (ssr || !srv('showAutoRemovalsPopup')) return
	const storageKey = 'cartAutoRemovals'

	store.watch(
		(state) => state.cart.order?.items,
		(newValue) => {
			const newOrderItems =
				newValue?.map((item) => {
					const { refId, name, qty, variantName, sku, image, unitMetric, cartItemId } = item
					return {
						refId,
						name,
						variantName,
						sku,
						qty,
						image: image?.fullUrl || '',
						unitMetric,
						cartItemId,
					}
				}) || []

			const localStorageValue = JSON.parse(localStorage.getItem(storageKey) || null)

			const { timestamp, orderItems } = localStorageValue || {}
			const validTimeWindow = timestamp
				? moment().subtract(72, 'hours').isBefore(moment(timestamp))
				: false
			const shouldCheckAutoRemovals = orderItems?.length && validTimeWindow
			if (shouldCheckAutoRemovals) {
				const cartAutoRemovals = orderItems.reduce((acc, localItem) => {
					const newItem = newOrderItems.find((i) => i.refId === localItem.refId)
					const wasRemoved = !newItem
					const qtyDecreasedAmount = wasRemoved ? 0 : newItem.qty - localItem.qty
					if (wasRemoved || qtyDecreasedAmount < 0) {
						acc.push({
							...localItem,
							removedQty: Math.abs(qtyDecreasedAmount),
							qty: newItem?.qty || 0,
							oldQty: localItem.qty,
							unitMetric: localItem.unitMetric,
						})
					}
					return acc
				}, [])

				store.set('cart/cartAutoRemovals', cartAutoRemovals.length ? cartAutoRemovals : null)
				store.set('cart/showCartAutoRemovals', !!cartAutoRemovals?.length)
			} else {
				store.set('cart/cartAutoRemovals', null)
			}

			if (newOrderItems.length) {
				if (JSON.stringify(newOrderItems) != JSON.stringify(orderItems)) {
					localStorage.setItem(
						storageKey,
						JSON.stringify({ timestamp: moment(), orderItems: newOrderItems })
					)
				}
			} else {
				localStorage.removeItem(storageKey)
			}
		},
		{ deep: true, immediate: true }
	)

	eventer.listen('checkout:step-submit', () => {
		window.localStorage.removeItem(storageKey)
	})
}

